
export type CustomRouteResponse =
  | CustomRouteResponseCompleted
  | CustomRouteResponseNotCompleted;
  
export interface CustomRouteResponseNotCompleted {
  status: 202;
  error: string;
}

export interface CustomRouteResponseCompleted {
  status: 200;
  message?: string; // Response message for modify endpoint (eidted daily route)
  id: number;
  token?: string; // only loading route from email
  language?: string;
  dailyRoutes: DailyRouteResponse;
  stats?: {
    dailyStats: DailyStats[]; // per day
    globalStats: GlobalStats;
  } 
}

export interface DailyRouteResponse {
  id: number;
  date: string;
  weather: WeatherResponse | null;
  points: Point[];
  startPoint: PointLocation;
  endPoint: PointLocation | null;
}

export interface WeatherResponse {
  tmax: number; // Max temperature
  tmin: number; // Min temperature
  iconName: string; // Weather icon name
  status: string; // Weather status (e.g., sunny, rainy)
  rain: number; // % rain probability
}

export interface Point {
  id: number;
  type: string; // TODO: ADAPTER POINT O EVENT
  category: CategoryPoint[];
  img: string;
  title: string;
  startDate: string; // TODO: ADAPTER: DATE
  endDate: string; // TODO: ADAPTER: DATE
  duration: number;
  previousLocation: PointLocation;
  currentLocation: PointLocation;
  polylinesPath: PointLocation[];
  totalTransferDistance: number;
  totalTransferDuration: number;
  transfers: Transfers[];
  transportList: Transport[] | null; 
  nextPoint: string;
  relateds?: boolean;
  relatedsItems?: any[];
  immersive: boolean;
}

export interface CategoryPoint {
  id: number;
  name: NameCategoryPoint;
  nameSlug: NameSlugCategoryPoint;
}

type Name = Record<string, string>; // e.g., { "es": "Museo", "en": "Museum" }
export type NameCategoryPoint = Name;
export type NameSlugCategoryPoint = Name;

interface Transfers {
  instruction: string,
  distance: number,
  duration: number, // minutes
  location: PointLocation,
  mode: string,
  icon: TransferIconName 
}

export interface DailyStats {
  date: string; // YYYY-MM-DD
  day: number;
  estimatedEmissions: string;
  estimatedPrice: string;
  publicTransportDistance: string;
  publicTransportDuration: string;
  totalDistance: string;  
  totalDuration: string;
  walkingDistance: string;
  walkingDuration: string;
  walkingRatio: string;
  weather: WeatherStatsResponse;
}

export interface WeatherStatsResponse {
  avgTemp: number;
  iconName: string;
  rain: number;
  status: string;
  tmax: number;
  tmin: number;
}

export interface GlobalStats {
  numberOfDays: number;
  totalDistance: string;
  totalDuration: string;
  totalEmissions: string;
  totalPrice: string;
  totalPublicTransportDistance: string;
  totalPublicTransportDuration: string;
  totalWalkingDistance: string;
  totalWalkingDuration: string;
  walkingRatio: string;
}

export type TransferIconName = keyof typeof TransferIconNameMap;
export const TransferIconNameMap = {
  straight: 'straight',
  'turn-left': 'turn-left',
  'turn-right': 'turn-right',
  'turn-slight-left': 'turn-slight-left',
  'turn-slight-right': 'turn-slight-right',
  'u-turn-left': 'u-turn-left',
  walk: 'walk', // destination reached
} as const;

interface PointLocation {
  lat: number;
  lng: number;
  address?: string;
}

interface Transport {
  id: number;
  name: string;
  instruction: string; // e.g., "Line 1", "Line 2"
  duration: number; // FifteenMinutes
  iconName: TransportListIconName;
}

export type TransportListIconName = keyof typeof TransportListIconNameMap;

export const TransportListIconNameMap = { // ? NOT SURE THE NAME OF ALL THE TYPES
  walk: 'walk',
  bike: 'bike',
  'bus-interurbano': 'bus-interurbano',
  'bus-emt': 'bus-emt',
  metro: 'metro',
  'metro-ligero': 'metro-ligero',
  cercanias: 'cercanias',
} as const;

// GUARDS:
export function isCustomRouteResponseCompleted(res: CustomRouteResponse): res is CustomRouteResponseCompleted {
  return res.status === 200;
}